<template>
  <v-navigation-drawer id="app-drawer" v-model="drawer" app dark>
    <v-img
      height="100%"
      class="imgBg"
      gradient="to top, rgba(27,27,27,.74), rgba(27,27,27,.74)"
      :src="imgSrc"
    >
      <v-list-tile class="mx-3 my-0" avatar>
        <v-list-tile-title class="white--text title font-weight-light">{{ appTitle }}</v-list-tile-title>
      </v-list-tile>

      <v-divider class="mx-3"></v-divider>

      <v-list dark>
        <v-list-tile
          v-for="(item, index) in items"
          :key="index"
          class="mx-4"
          :to="item.to"
          :active-class="color"
        >
          <v-list-tile-action>
            <v-icon>{{ item.icon }}</v-icon>
          </v-list-tile-action>

          <v-list-tile-title>{{ item.text }}</v-list-tile-title>
        </v-list-tile>
      </v-list>
      <div style="height:100%">
        <span style="position: absolute; bottom: 0;" class="caption grey--text">
          źródło:
          <a>www.slupczewski.pl</a>, Michał Słupczewski
        </span>
      </div>
    </v-img>
  </v-navigation-drawer>
</template>

<script>
import { mapState } from 'vuex';

import { eventBus } from '@/main';

// @vuese
// Menu boczne
// @group MainLayout
export default {
  data() {
    const navbarItems = [
      { icon: 'mdi-view-dashboard', to: '/', text: 'Home' },
      { icon: 'mdi-view-dashboard', to: '/example2', text: 'Druga zakładka' },
      { icon: 'mdi-view-dashboard', to: '/example3', text: 'Trzecia zakładka' }
    ];
    return {
      drawer: true,
      items: navbarItems,
      imgSrc: '/img/tlo.jpg',
      color: 'green'
    };
  },
  methods: {
    // @vuese
    // Metoda włączająca i wyłączająca menu
    toggleMenu() {
      this.drawer = !this.drawer;
    }
  },
  computed: mapState({
    appTitle: state => state.system.appTitle
  }),
  beforeMount() {
    eventBus.$on('toggleMenu', () => this.toggleMenu());
  }
};
</script>
